import PropTypes from 'prop-types';

const AboutPropTypesMixin = {
  propTypes: {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    tour_name: PropTypes.string.isRequired,
    tagline: PropTypes.string.isRequired,
    location: PropTypes.string,
    description: PropTypes.string.isRequired,
    guide_name: PropTypes.string.isRequired,
    guide_picture_url: PropTypes.string,
    guide_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
      .isRequired,
    total_reviews: PropTypes.number,
    tourName: PropTypes.string,
  },
};

export default AboutPropTypesMixin;
